import { environment } from '../../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('FeatureCategoryService', FeatureCategoryService);

  FeatureCategoryService.$inject = [
    'RestResource',
    'CONFIGURATIONS',
    '$translate',
    '$filter',
    'UtilService',
    'TranslationModalService',
    'WindowModalService',
  ];

  function FeatureCategoryService(
    RestResource,
    config,
    $translate,
    $filter,
    UtilService,
    TranslationModalService,
    WindowModalService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'feature_categories';

    var service = {
      getFilterCriteria: getFilterCriteria,
      getFeatureCategories: getFeatureCategories,
      getFeatureCategory: getFeatureCategory,
      saveFeatureCategory: saveFeatureCategory,
      openFeatureCategoryTranslations: openFeatureCategoryTranslations,
      openFeatureCategoryDetailModal: openFeatureCategoryDetailModal,
    };

    return service;

    ////////////////

    function getFilterCriteria() {
      var filterCriteria = {
        page: 1,
        sortDir: 'asc',
        sortedBy: 'name',
      };

      return filterCriteria;
    }

    function getFeatureCategories(filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria();
      }

      return RestResource.request(
        'get',
        apiUrl,
        filterCriteria,
        function (response) {
          response = response.data;

          if (response.meta) {
            return {
              items: response.data,
              meta: utils.getItemsMetaData(response, filterCriteria),
            };
          } else {
            return {
              items: response,
            };
          }
        },
        {}
      );
    }

    function getFeatureCategory(id, language) {
      var params = { lang: null };

      if (language) {
        params.lang = language;
      }

      return RestResource.request(
        'get',
        apiUrl + '/' + id,
        params,
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveFeatureCategory(item, language) {
      var itemAddedMsg = $translate('NEW_ADDED_CATEGORY');
      var itemAddedFlashMsg =
        $translate('CATEGORY_ADDED_MSG') + ' ' + $translate('REMEMBER_ADD_TRANSLATIONS');
      var itemModifiedMsg = $translate('MODIFIED_CATEGORY');

      var method = item.id ? 'put' : 'post';
      var url = item.id ? apiUrl + '/' + item.id : apiUrl;

      var lang = language ? language : config.DEFAULT_CONTENT_LANGUAGE;

      function success(response) {
        var msg = item.id ? itemModifiedMsg : itemAddedMsg;
        utils._successMsg(msg);

        if (!item.id) {
          // Create
          utils._setFlashMessage(itemAddedFlashMsg);
        }

        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      return RestResource.request(
        method,
        url,
        { feature_category: item, lang: lang },
        success,
        failure
      );
    }

    function openFeatureCategoryTranslations(item, additionalLanguages) {
      var template =
        './app/ajs/admin/feature-categories/modals/feature-category-detail-translation.html';

      var modalParams = {
        title: item.name,
        item: item,
        additionalLanguages: additionalLanguages,
      };

      var initializeCallback = function (itemId, language) {
        return getFeatureCategory(itemId, language).then(function (data) {
          return data;
        });
      };

      var confirmCallback = function (item, language) {
        return saveFeatureCategory(item, language).then(function (data) {
          if (!data.status) {
            return data.response;
          }

          return false;
        });
      };

      TranslationModalService.open(template, modalParams, initializeCallback, confirmCallback);
    }

    function openFeatureCategoryDetailModal(item, additionalLanguages, mode) {
      var templateUrl =
        './app/ajs/admin/feature-categories/modals/feature-category-detail-modal.html';

      var originalItem = angular.copy(item);

      var modalParams = {
        title: 'CATEGORY_DETAILS',
        item: originalItem,
        additionalLanguages: additionalLanguages,
        mode: mode,
      };

      var confirmCallback = function (selectedItem) {
        item.name = selectedItem.name;
        item.description = selectedItem.description;
        item.type = selectedItem.type;
        item.visible_as_addon = selectedItem.visible_as_addon;

        return utils.itemListChanged(selectedItem.id);
      };

      WindowModalService.open(templateUrl, modalParams, confirmCallback);
    }
  }
})();
